import React from "react";
import { useAppDispatch, useAppSelector } from "store/hooks/hooks";
import { closeGlobalDialog } from "store/slices/globalDialogSlice";
import ButtonPrimary from "../Button/ButtonPrimary";

const GlobalDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isOpen, message, onConfirm } = useAppSelector((state) => state.globalDialog);

  if (!isOpen) return null;

  const handleOk = () => {
    if (onConfirm) {
      onConfirm();
    } else {
      dispatch(closeGlobalDialog());
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
      <div className="bg-white dark:bg-slate-800 rounded-lg shadow-lg p-6 max-w-md w-full">
        <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200">
          Notice
        </h2>
        <p className="mt-2 text-slate-600 dark:text-slate-300">{message}</p>
        <div className="mt-4 flex justify-end">
          <ButtonPrimary
            onClick={handleOk}
          >
            Okay
          </ButtonPrimary>
        </div>
      </div>
    </div>
  );
};

export default GlobalDialog;
